<template>
    <section>
        <a-form class="form-container" :form="form">
            <a-row type="flex" :gutter="20">
                <a-col :span="8">
                    <a-form-item label="单位名称"  >
                        <a-select showSearch option-filter-prop="children" placeholder="请选择" v-decorator="['companyId',{rules:[{required:false,message:'请输入单位名称'}]}]" @change="e => changeCompany(e)">
                            <a-select-option v-for="item in companyMap" :key="item.id" :value="item.id">{{item.companyName}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="班组名称" >
                        <a-select showSearch option-filter-prop="children" placeholder="请选择" v-decorator="['teamId',{rules:[{required:personnelId ? false : true,message:'请输入班组名称'}]}]" @change="e => changeTeam(e)">
                            <a-select-option v-for="item in teamMap" :key="item.id" :value="item.id">{{item.teamName}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                 <a-col :span="8">
                    <a-form-item label="人员姓名 " >
                        <a-select showSearch option-filter-prop="children" :placeholder="teamId ? '全部': '请选择'" v-decorator="['personnelId',{rules:[{required:teamId ? false : true,message:'请选择人员'}]}]" @change="e => queryPersonnelDetails(e)">
                            <a-select-option v-if="teamId && personnelLists.length > 0" value="">全部</a-select-option>
                            <a-select-option v-for="item in personnelLists" :key="item.id" :value="item.id">{{item.personnelName}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row class="info-container scroll-container m-b-18" v-if="personnelId">
                <section class="info-item-wrap">
                    <p class="info-title">人员信息</p>
                    <a-row class="m-t-18">
                        <a-col :span="24">
                            <a-row class="info-item">
                                <a-col class="key">人脸照片</a-col>
                                <a-col class="val">
                                    <img style="width:80px;height:100px" :src="picServer+personnelInfo.avatar" alt="">
                                </a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">人员姓名</a-col>
                                <a-col class="val">{{personnelInfo.personnelName}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">身份证号</a-col>
                                <a-col class="val">{{personnelInfo.idCard}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">签发机关</a-col>
                                <a-col class="val">{{personnelInfo.issuingAuthority}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">民族</a-col>
                                <a-col class="val">{{personnelInfo.nation}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">性别</a-col>
                                <a-col class="val">{{personnelInfo.sex === 1 ? '男' : personnelInfo.sex === 2 ? '女' : ''}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">户籍地址</a-col>
                                <a-col class="val">{{personnelInfo.residenceAddress}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">政治面貌</a-col>
                                <a-col class="val">{{personnelInfo.residenceAddress === 1 ? '党员' : '非党员'}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">联系电话</a-col>
                                <a-col class="val">{{personnelInfo.phoneNumber}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">婚姻状态</a-col>
                                <a-col class="val">{{personnelInfo.maritalStatus === 1 ? '已婚' : '未婚'}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">教育水平</a-col>
                                <a-col class="val">
                                    {{
                                        personnelInfo.educationLevel === 1 ? '初中' : 
                                        personnelInfo.educationLevel === 2 ? '高中' :
                                        personnelInfo.educationLevel === 3 ? '中专' :
                                        personnelInfo.educationLevel === 4 ? '大专' :
                                        personnelInfo.educationLevel === 5 ? '本科' :
                                        personnelInfo.educationLevel === 6 ? '硕士' :
                                        personnelInfo.educationLevel === 7 ? '博士' : ''
                                        
                                    }}
                                    </a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">家庭地址</a-col>
                                <a-col class="val">{{personnelInfo.familyAddress}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">开户行</a-col>
                                <a-col class="val">{{personnelInfo.payBankname}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">银行卡号</a-col>
                                <a-col class="val">{{personnelInfo.payCardnum}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">所属支行</a-col>
                                <a-col class="val">{{personnelInfo.payCardnum}}</a-col>
                            </a-row>
                        </a-col>
                        <a-col :span="8">
                            <a-row class="info-item">
                                <a-col class="key">是否标记</a-col>
                                <a-col class="val">{{personnelInfo.liveBuiltBureau === 1 ? '是' : '否'}}</a-col>
                            </a-row>
                        </a-col>
                    </a-row>
                </section>
                 <section class="info-item-wrap">
                <p class="info-title">紧急联系人</p>
                <a-row class="m-t-18">
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">联系人姓名</a-col>
                            <a-col class="val">{{personnelInfo.emergencyContact}}</a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">联系人电话</a-col>
                            <a-col class="val">{{personnelInfo.contactNumber}}</a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </section>
             <!-- 职务信息 -->
             <section class="info-item-wrap" v-if="personnelInfo.personnelType == 1 || personnelInfo.personnelType == 2">
                <p class="info-title">职务信息</p>
                <a-row class="m-t-18">
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">职务名称</a-col>
                            <a-col class="val">{{personnelInfo.positionWorkName}}</a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </section>
            
             <!-- 班组信息 -->
            <section class="info-item-wrap" v-if="personnelInfo.personnelType == 3">
                <p class="info-title">班组信息</p>
                <a-row class="m-t-18">
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">班组名称</a-col>
                            <a-col class="val">{{personnelInfo.teamName}}</a-col>
                        </a-row>
                    </a-col>
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">是否组长</a-col>
                            <a-col class="val">{{personnelInfo.isLeader === 1 ? '是' : '否'}}</a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </section>
            <!-- 工种信息 -->
             <section class="info-item-wrap" v-if="personnelInfo.personnelType == 3">
                <p class="info-title">工种信息</p>
                <a-row class="m-t-18">
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">工种名称</a-col>
                            <a-col class="val">{{personnelInfo.positionWorkName}}</a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </section>
            <section class="info-item-wrap">
                <p class="info-title">出入场信息</p>
                <a-row class="m-t-18">
                    <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">登记时间</a-col>
                            <a-col class="val">{{personnelInfo.inDate}}</a-col>
                        </a-row>
                    </a-col>
                     <a-col :span="8">
                        <a-row class="info-item">
                            <a-col class="key">退场时间</a-col>
                            <a-col class="val">{{personnelInfo.outDate}}</a-col>
                        </a-row>
                    </a-col>
                </a-row>
            </section>
            </a-row>
            <a-row  type="flex" :gutter="20">
               
                <a-col :span="8">
                    <a-form-item label="结算类型 " >
                        <a-select placeholder="请选择" v-decorator="['type',{rules:[{required:true,message:'请选择结算类型'}]}]">
                            <a-select-option v-for="item in typeList" :key="item.id" :value="item.id">{{item.name}}</a-select-option>
                        </a-select>
                    </a-form-item>
                </a-col>
                <a-col :span="8">
                    <a-form-item label="结算单价(元)" >
                        <a-input placeholder="请输入" v-decorator="['payPrice',{rules:[{required:true,message:'请输入结算单价'}]}]" />
                    </a-form-item>
                </a-col>
                <!-- <a-col :span="8">
                    <a-form-item label="加班单价/小时" >
                        <a-input placeholder="请输入" v-decorator="['overtimePrice',{rules:[{required:true,message:'请输入加班单价'}]}]" />
                    </a-form-item>
                </a-col> -->
            </a-row>
            <a-row>
                <a-col :span="16">
                    <a-form-item label="备注" >
                        <a-textarea placeholder="备注" rows="4" v-decorator="['remarks',{rules:[{required:false,message:'请输入备注'}]}]"></a-textarea>
                    </a-form-item>
                </a-col>
            </a-row>
            <a-row class="form-btn-group">
                <a-col :span="16">
                    <a-button @click="submit" :disabled="submitLoadding" :loading="submitLoadding"><a-icon v-if="!submitLoadding" type="save" />保存</a-button>
                    <a-button @click="$router.back()">取消</a-button>
                </a-col>
            </a-row>
        </a-form>
    </section>
</template>

<script>
// import selectPersonnelCascader from '@/components/select-personnel-cascader'
export default {
    data(){
        return{
            companyMap:[],
            companyId:'',
            teamMap:[],
            formInfo:{},
            personnelId:'',
            teamId:'',
            personnelLists:[],
            typeList:[],
            personnelInfo:{}
        }
    },
    // components:{selectPersonnelCascader},
    beforeCreate(){
        this.form = this.$form.createForm(this)
    },
    created(){
        this.init()
    },
    
    computed:{
        sid(){
            return this.$route.query.id
        },
        picServer(){
            return this.$store.state.picServer
        },
        submitLoadding(){
            return this.$store.state.submitLoadding
        }
    },
    mounted(){
        this.sid && this.queryCompanyPaySalaryConfigDetails()
    },
    methods:{
        init(){
            this.queryCompanyDropDownBox()
            this.queryTeamDropDownBox()
            this.queryPersonnelOptionsList()
            this.queryCompanyPayTypeList()
        },
        //结算类型下拉
        queryCompanyPayTypeList(){
            this.$api.queryCompanyPayTypeList().then(res =>{
                if(res.code === 200){
                    this.typeList = (res.data && res.data.records) || []
                }
            })
        },
        
        //单位下拉
        queryCompanyDropDownBox(){
            this.$api.queryCompanyDropDownBox().then(res =>{
                if(res.code === 200){
                    this.companyMap = res.data || []
                }
            })
        },
        changeCompany(companyId){
            this.companyId = companyId
            
            this.queryTeamDropDownBox()
            this.queryPersonnelOptionsList()
            this.form.setFieldsValue({
                teamId:'',
                personnelId:null
                
            })
            this.personnelId = ''
        },
        //班组下拉
        queryTeamDropDownBox(){
            this.$api.queryTeamDropDownBox({companyId:this.companyId}).then(res =>{
                if(res.code === 200){
                    this.teamMap = res.data || []
                }
            })
        },
        changeTeam(teamId){
            this.teamId = teamId || ''
            this.queryPersonnelOptionsList()
            this.form.setFieldsValue({
                personnelId:null
            })
            this.personnelId = ''
        },
        //人员下拉
        queryPersonnelOptionsList(){
            let params ={}
            if(this.companyId){
                params.companyId = this.companyId
            }
            if(this.teamId){
                params.teamId = this.teamId
            }
            this.$api.queryPersonnelOptionsList(params).then(res =>{
                if(res.code === 200){
                    this.personnelLists = res.data  || []
                }
            })
        },
        queryPersonnelDetails(id){
            
            if(!id) return false
            this.personnelId = id
            this.$api.queryPersonnelDetails({id}).then(res =>{
                if(res.code === 200){
                    let _data = res.data || {}
                    this.personnelInfo = _data.personnelInfo
                     this.personnelInfo.companyName = _data.companyName
                    this.personnelInfo.companyTypeName = _data.companyTypeName
                    this.personnelInfo.socialCreditCode = _data.socialCreditCode
                    this.personnelInfo.positionWorkName = _data.positionWorkName
                    this.personnelInfo.teamName = _data.teamName
                    this.personnelInfo.isLeader = _data.isLeader
                }
            })
        },
        
        //工资设置详情
        queryCompanyPaySalaryConfigDetails(){
            this.$api.queryCompanyPaySalaryConfigDetails(this.sid).then(res =>{
                if(res.code === 200){
                    let info = res.data || {}
                    let formData = {
                        companyId:info.companyId,
                        teamId:info.teamId,
                        remarks:info.remarks,
                        // overtimePrice:info.overtimePrice,
                        payPrice:info.payPrice,
                        personnelId:info.personnelId,
                        type:info.type
                    }
                    this.companyId = info.companyId
             
                    this.queryPersonnelDetails(info.personnelId)
                    this.$nextTick(() =>{
                        this.form.setFieldsValue(formData)
                    })
                    
                }
            })
        },
        submit(){
            this.form.validateFields((err,formData) =>{
                if(!err){
                    this.$store.commit('SET_SUBMITLOADDING',true)
                    if(this.sid){
                        formData.id = this.sid
                    }
                    let apiName = this.sid ? 'updateCompanyPaySalaryConfig' : 'insertCompanyPaySalaryConfig'
                    this.$api[apiName](formData).then(res =>{
                        if(res.code === 200){
                            this.$router.back()
                        }
                    })
                }
            })
        }
    }
    
}
</script>

<style lang="scss" scoped>
    .info-container{
        background: rgba(0,0,0,0.3);
        border-radius: 4px;
        height: auto;
    }
</style>